import { render } from "./GlobalLoader.vue?vue&type=template&id=02d8f1dc"
import script from "./GlobalLoader.vue?vue&type=script&lang=js"
export * from "./GlobalLoader.vue?vue&type=script&lang=js"

import "./GlobalLoader.vue?vue&type=style&index=0&id=02d8f1dc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__